import React, { useEffect, useState } from "react";
import Nodata from "../../assets/Nodatasurgery.svg";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { format } from "date-fns";
import { ArrowLeft, MapPin, CheckCircle, Eye, Share2, ChevronLeft, ChevronRight } from "lucide-react";
import {
  FiThermometer,
  FiActivity,
  FiDroplet,
  FiHeart,
  FiTrendingUp,
  FiTrendingDown,
} from "react-icons/fi";
import { toast } from "react-toastify";
import OurLayouts from "../layout";
import Surgerydetailsicon from "../../assets/surgerydetailsicon.svg";
import Insuranceicon from "../../assets/insuranceicon.svg";



const HOSPITAL_API_BASE = process.env.REACT_APP_SURGERY_STATUS;
const PATIENT_API_BASE = process.env.REACT_APP_API_URL_PATIENTS;
const OMS_API_BASE = process.env.REACT_APP_OMS_URL;
const GOOGLE_STORAGE_BASE = process.env.REACT_APP_API_GOOGLE_URL;
const COMMON_API_BASE = process.env.REACT_APP_NEWBASEURL;


const STATUS_RANGES = {
  temperature:     (v) => v < 97 ? "low" : v <= 99 ? "normal" : v <= 100.4 ? "slight" : "high",
  respirationRate: (v) => v < 12 ? "low" : v <= 20 ? "normal" : v <= 25 ? "slight" : "high",
  systolic:        (v) => v < 120 ? "normal" : v < 130 ? "slight" : "high",
  spo2:            (v) => v >= 95 ? "normal" : v >= 90 ? "slight" : "low",
  heartRate:       (v) => v < 60 ? "low" : v <= 100 ? "normal" : v <= 120 ? "slight" : "high",
  height:          () => "normal",
  weight:          () => "normal",
  bloodGlucose:    (v) => v < 70 ? "low" : v < 100 ? "normal" : v < 126 ? "slight" : "high",
};

const STATUS_META = {
  normal: { label: "Normal",     cls: "border border-[#C9CDD4] text-[#6B7280] bg-white" },
  slight: { label: "Slight High",cls: "border border-[#F59E0B] text-[#D97706] bg-white" },
  high:   { label: "High",       cls: "border border-[#DC2626] text-[#DC2626] bg-red-50" },
  low:    { label: "low BP",     cls: "border border-[#F59E0B] text-[#D97706] bg-white" },
};

function getStatus(key, raw) {
  if (raw == null || raw === 0 || !STATUS_RANGES[key]) return null;
  const level = STATUS_RANGES[key](Number(raw));
  return STATUS_META[level];
}

function VitalCard({ label, value, icon, statusKey, rawValue, index }) {
  const status = getStatus(statusKey, rawValue);
  const bg = index % 2 === 0 ? "bg-[#EEF9F2]" : "bg-[#EBF5FF]";
  return (
    <div className={`${bg} rounded-2xl px-4 py-4`}>
      <div className="flex items-start justify-between mb-4">
        <span className="text-[26px] text-[#2F9D64]">{icon}</span>
        {status && (
          <span className={`text-[11px] font-semibold px-2.5 py-0.5 rounded-lg ${status.cls}`}>
            {status.label}
          </span>
        )}
      </div>
      <p className="text-[14px] font-semibold text-[#2F9D64] mb-1">{label}</p>
      <p className="text-[20px] font-bold text-[#0B2340]">{value}</p>
    </div>
  );
}

const getInitials = (name) =>
  (name || "?")
    .split(" ")
    .filter(Boolean)
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

const formatDob = (value) => {
  if (!value) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? String(value) : format(parsed, "dd/MM/yyyy");
};

const calcAge = (dob) => {
  if (!dob) return null;
  const birth = new Date(dob);
  if (Number.isNaN(birth.getTime())) return null;
  const diff = Date.now() - birth.getTime();
  return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
};

const InfoItem = ({ label, value }) => {
  if (!value) return null;
  return (
    <div className="flex flex-wrap gap-1 items-baseline">
      <span className="text-[13px] font-bold text-[#374151] whitespace-nowrap">{label} :</span>
      <span className="text-[13px] text-[#4B5563]">{value}</span>
    </div>
  );
};

const TABS = ["Vitals", "Test Report", "Surgery Enquiry"];


export default function CampPatientDetailPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { enquiryId, patient: rowPatient, campCode, campName, campLocation, campStartDate,campEndDate } =
    location.state || {};

  const [enquiry, setEnquiry] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("Vitals");
  const [vitals, setVitals] = useState([]);
  const [vitalsLoading, setVitalsLoading] = useState(false);
  const [labOrders, setLabOrders] = useState([]);
  const [labLoading, setLabLoading] = useState(false);
  const [labPage, setLabPage] = useState(0);
  const [labTotalPages, setLabTotalPages] = useState(1);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [patientProfile, setPatientProfile] = useState(null);
  const [hospTypes, setHospTypes] = useState([]);

  useEffect(() => {
    if (!enquiryId) {
      toast.error("Enquiry ID not found.");
      navigate(-1);
      return;
    }

    const fetchDetails = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("auth_token");
        const { data } = await axios.get(
          `${HOSPITAL_API_BASE}enquiry/getEnquiryById`,
          {
            params: { enquiryId },
            headers: token ? { Authorization: `Bearer ${token}` } : {},
          }
        );
        setEnquiry(data?.successObject || null);
        console.log(data?.successObject,"fcgvhbjnkm")
        if (!data?.successObject) toast.error("Enquiry details not found.");
      } catch (err) {
        console.error("Failed to fetch enquiry details:", err);
        toast.error("Failed to load enquiry details.");
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [enquiryId, navigate]);

  useEffect(() => {
    const serviceType = enquiry?.serviceType;
    const hospitalizationTypeId = enquiry?.hospitalizationType || enquiry?.hospitalizationTypeId;
    if (!serviceType || !hospitalizationTypeId || !COMMON_API_BASE) return;

    const fetchHospTypes = async () => {
      try {
        const { data } = await axios.get(
          `${COMMON_API_BASE}hospitalizationServiceType/list/filter?serviceType=${serviceType}&hospitalizationTypeId=${hospitalizationTypeId}`
        );
        setHospTypes(Array.isArray(data?.data) ? data.data : []);
      } catch (err) {
        console.error("Failed to fetch hospitalization types:", err);
      }
    };

    fetchHospTypes();
  }, [enquiry]);

  useEffect(() => {
    console.log(rowPatient,"rowPatient")
    const patientCode = rowPatient?.patientId ;
   

    const fetchVitals = async () => {
      setVitalsLoading(true);
      try {
        const token = localStorage.getItem("access_token");
        const { data } = await axios.get(
          `${PATIENT_API_BASE}PatientVitals/list/filter?patientCode=${patientCode}`,
          { headers: token ? { Authorization: `Bearer ${token}` } : {} }
        );
        console.log(data[0],"rdtfyguhijk")
        setVitals(Array.isArray(data) ? data : data?.data || []);
      } catch (err) {
        console.error("Failed to fetch vitals:", err);
      } finally {
        setVitalsLoading(false);
      }
    };

    fetchVitals();
  }, [rowPatient]);

  useEffect(() => {
    const patientId = rowPatient?.patientId;
    if (!patientId || !PATIENT_API_BASE) return;

    const fetchPatientProfile = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const { data } = await axios.get(
          `${PATIENT_API_BASE}patient/${patientId}`,
          { headers: token ? { Authorization: `Bearer ${token}` } : {} }
        );
        setPatientProfile(data || null);
      } catch (err) {
        console.error("Failed to fetch patient profile:", err);
      }
    };

    fetchPatientProfile();
  }, [rowPatient]);
console.log(patientProfile,"cfgvhbjkn")
  useEffect(() => {
    const patientId = rowPatient?.patientId;
   

    const fetchLabOrders = async () => {
      setLabLoading(true);
      try {
        const token = localStorage.getItem("access_token");
           const API_BASE = process.env.REACT_APP_API_URL_CHE || "";
        const { data } = await axios.get(
          `${API_BASE}LabTestsOrderReport/list/filter?patientId=SMvdm0656p&docmentRequired=Y`,
          { headers: token ? { Authorization: `Bearer ${token}` } : {} }
        );
        setLabOrders(Array.isArray(data) ? data : data?.data || []);
      
      } catch (err) {
        console.error("Failed to fetch lab orders:", err);
      } finally {
        setLabLoading(false);
      }
    };

    fetchLabOrders();
  }, [rowPatient]);

  const patientDetails = enquiry?.patientDetails || {};
  const addressDetails = enquiry?.addressDetails || {};

  const displayName =
    [patientProfile?.salutation || patientDetails.salutation, patientProfile?.firstName || patientDetails.firstName, patientProfile?.lastName || patientDetails.lastName]
      .filter(Boolean)
      .join(" ") ||
    enquiry?.name ||
    rowPatient?.patientName ||
    "—";

  const mobile = patientProfile?.mobile || patientDetails.mobile || enquiry?.contactNumber || rowPatient?.patientContactNumber || "";
  const email = patientProfile?.email || patientDetails.email || enquiry?.emailId || rowPatient?.patientEmail || "";
  const dob = patientProfile?.dob || patientDetails.dob || enquiry?.dob;
  const age = calcAge(dob);
  const gender = patientProfile?.gender || patientDetails.gender || enquiry?.gender || "";
  const abhaNumber = patientProfile?.abhaNumber || patientDetails.abhaNumber || enquiry?.abhaNumber || "";
  const abhaAddress = patientProfile?.preferredAbhaAddress || patientProfile?.abhaAddress || patientDetails.abhaAddress || enquiry?.abhaAddress || "";
  const pincode = patientProfile?.pinCode || addressDetails.pinCode || enquiry?.pinCode || "";
  const clinicName = enquiry?.eclinicName || enquiry?.hospitalName || localStorage.getItem("clinicname") || "";

  return (
    <OurLayouts>
      <div className="w-full px-3 sm:px-6 py-5 max-w-[1400px] mx-auto">

       

        {loading ? (
          <div className="flex flex-col items-center justify-center py-24">
            <div className="w-10 h-10 border-2 border-[#00B58F] border-t-transparent rounded-full animate-spin mb-4" />
            <p className="text-[14px] text-[#6B7280]">Loading patient details…</p>
          </div>
        ) : (
          <div className="space-y-4">

            {/* ── Top cards ── */}
            <div className="flex flex-col lg:flex-row gap-4">

              {/* Patient info card */}
              <div className="flex-1 bg-white rounded-2xl shadow-sm overflow-hidden border border-[#E8EEF5]">
                {/* Gradient top strip */}
                <div className="h-1.5 w-full" style={{ background: "linear-gradient(90deg, #004376, #00BA7E)" }} />
                <div className="p-5 flex items-start gap-5">
                  {/* Avatar */}
                  <div className="shrink-0">
                    <div className="w-[60px] h-[60px] rounded-full flex items-center justify-center text-white text-[18px] font-bold shadow-lg border-4 border-white" style={{ background: "linear-gradient(135deg, #004376, #00BA7E)" }}>
                      {getInitials(displayName)}
                    </div>
                  </div>

                  {/* Info */}
                  <div className="flex-1 min-w-0 mt-3">
                    <p className="text-[17px] font-bold text-[#0B4D76] mb-0.5">Patient: {displayName}</p>
                    {/* {clinicName && (
                      <span className="inline-flex items-center gap-1 px-2.5 py-0.5 bg-[#EEF4FB] rounded-full text-[11px] font-semibold text-[#0B4D76] border border-[#C8D8EA] mb-3">
                        {clinicName}
                      </span>
                    )} */}
                    <div className="mt-3 flex flex-wrap gap-x-8 gap-y-2.5">
                      <InfoItem label="Phone Number" value={mobile} />
                      <InfoItem label="Email Address" value={email} />
                      <InfoItem label="DOB" value={formatDob(dob)} />
                      <InfoItem label="Age" value={age ? String(age) : null} />
                      <InfoItem label="Gender" value={gender === "M" ? "Male" : gender === "F" ? "Female" : gender} />
                      <InfoItem label="ABHA Number" value={abhaNumber} />
                      <InfoItem label="ABHA Address" value={abhaAddress} />
                      <InfoItem label="Pincode" value={pincode} />
                    </div>
                  </div>
                </div>
              </div>

              {/* ABHA Account card */}
              {(abhaNumber || abhaAddress) && (
                <div className="lg:w-[280px] bg-white rounded-2xl border border-[#E8EEF5] shadow-sm overflow-hidden">
                  <div className="h-1.5 w-full" style={{ background: "linear-gradient(90deg, #004376, #00BA7E)" }} />
                  {/* Header */}
                  <div className="flex items-center justify-between px-4 py-2.5 bg-[#E8F8F2] border-b border-[#C8E8D8]">
                    <div className="flex items-center gap-1.5">
                      <CheckCircle size={14} className="text-[#00874E]" />
                      <span className="text-[12px] font-bold text-[#00593A]">ABHA Account</span>
                    </div>
                    <span className="text-[11px] font-bold text-white bg-[#00874E] px-2.5 py-0.5 rounded-full">
                      Verified
                    </span>
                  </div>
                  {/* Body */}
                  <div className="px-4 py-4">
                    <div className="flex items-center justify-between gap-2 mb-3">
                      <div>
                        <p className="text-[14px] font-bold text-[#0B4D76]">{displayName}</p>
                        <p className="text-[12px] text-[#6B7280] mt-0.5">
                          {[mobile, gender].filter(Boolean).join("  •  ")}
                        </p>
                      </div>
                      <div className="w-10 h-10 rounded-full flex items-center justify-center text-white text-[12px] font-bold shrink-0 shadow" style={{ background: "linear-gradient(135deg, #004376, #00BA7E)" }}>
                        {getInitials(displayName)}
                      </div>
                    </div>
                    <div className="space-y-2 border-t border-[#F0F4FA] pt-3">
                      {abhaNumber && (
                        <div>
                          <p className="text-[10px] font-semibold text-[#9CA3AF] uppercase tracking-wide mb-0.5">ABHA Number</p>
                          <span className="inline-block text-[12px] font-medium bg-[#1E3A5F] text-white px-2.5 py-0.5 rounded-md">
                            {abhaNumber}
                          </span>
                        </div>
                      )}
                      {abhaAddress && (
                        <div>
                          <p className="text-[10px] font-semibold text-[#9CA3AF] uppercase tracking-wide mb-0.5">ABHA Address</p>
                          <span className="inline-block text-[12px] font-medium bg-[#F0F4FA] text-[#374151] px-2.5 py-0.5 rounded-md">
                            {abhaAddress}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* ── Camp info bar ── */}
            {(campName || campCode) && (
              <div className="bg-[#EEF8FF] rounded-xl border border-[#C8E6F9] px-5 py-3 flex flex-wrap items-center gap-4">
                <MapPin size={16} className="text-[#0B4D76] shrink-0" />
                {campName && (
                  <div className="flex items-center gap-2 text-[13px]">
                    <span className="text-[#6B7280]">Camp Name:</span>
                    <span className="font-semibold text-[#0B4D76]">{campName}</span>
                  </div>
                )}
                {campLocation && (
                  <>
                    <span className="text-[#C8E6F9]">|</span>
                    <div className="flex items-center gap-2 text-[13px]">
                      <span className="text-[#6B7280]">Camp Location:</span>
                      <span className="font-semibold text-[#0B4D76]">{campLocation}</span>
                    </div>
                  </>
                )}
                {campStartDate &&  campEndDate &&(
                  <>
                    <span className="text-[#C8E6F9]">|</span>
                    <div className="flex items-center gap-2 text-[13px]">
                      <span className="text-[#6B7280]">Camp Date:</span>
                      <span className="font-semibold text-[#0B4D76]">{campStartDate} - {campEndDate}</span>
                    </div>
                  </>
                )}
               
               
              </div>
            )}

            {/* ── Tabs ── */}
            <div className="bg-white rounded-2xl border border-[#E5E7EB] shadow-sm overflow-hidden">
              <div className="flex border-b border-[#E5E7EB]">
                {TABS.map((tab) => (
                  <button
                    key={tab}
                    type="button"
                    onClick={() => setActiveTab(tab)}
                    className={`px-5 py-3.5 text-[13px] font-semibold transition-colors border-b-2 ${
                      activeTab === tab
                        ? "border-[#00BA7E] text-[#00BA7E]"
                        : "border-transparent text-[#6B7280] hover:text-[#374151]"
                    }`}
                  >
                    {tab}
                  </button>
                ))}
              </div>

              <div className="p-5">
                {activeTab === "Surgery Enquiry" && (
                  <SurgeryEnquiryTab enquiry={enquiry} hospTypes={hospTypes} onPreview={setPreviewUrl} />
                )}
                {activeTab === "Vitals" && (
                  vitalsLoading ? (
                    <div className="flex justify-center py-12">
                      <div className="w-8 h-8 border-2 border-[#00BA7E] border-t-transparent rounded-full animate-spin" />
                    </div>
                  ) : vitals.length === 0 ? (
                    <div className="py-10 flex flex-col items-center gap-3">
                      <img src={Nodata} alt="No data" className="w-64 h-32 opacity-70" />
                      <p className="text-[18px] font-medium bg-gradient-to-r from-[#004376] to-[#00BA7E] bg-clip-text text-transparent">
                        There is no vitals data recorded for this patient yet.
                      </p>
                    </div>
                  ) : (
                    <>
                    <p className="text-[16px] font-bold text-[#0B2340] mb-4">Vitals</p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
                      <VitalCard index={0} label="Temperature"      value={`${vitals[0].temperature} °F`}                       icon={<FiThermometer />}  statusKey="temperature"     rawValue={vitals[0].temperature} />
                      <VitalCard index={1} label="Respiration Rate" value={`${vitals[0].respirationRate} /min`}           icon={<FiActivity />}     statusKey="respirationRate" rawValue={vitals[0].respirationRate} />
                      <VitalCard index={0} label="Blood Pressure"   value={`${vitals[0].systolic}/${vitals[0].diastolic} mmHg`} icon={<FiDroplet />} statusKey="systolic"        rawValue={vitals[0].systolic} />
                      <VitalCard index={1} label="Oxygen Level"     value={`${vitals[0].spo2} %`}                         icon={<FiHeart />}        statusKey="spo2"            rawValue={vitals[0].spo2} />
                      <VitalCard index={0} label="Heart Rate"       value={`${vitals[0].heartRate} bpm`}                  icon={<FiHeart />}        statusKey="heartRate"       rawValue={vitals[0].heartRate} />
                      <VitalCard index={1} label="Height"           value={`${vitals[0].height} cm`}                      icon={<FiTrendingUp />}   statusKey="height"          rawValue={vitals[0].height} />
                      <VitalCard index={0} label="Weight"           value={`${vitals[0].weight} kg`}                      icon={<FiTrendingDown />}  statusKey="weight"         rawValue={vitals[0].weight} />
                      <VitalCard index={1} label="Blood Glucose"    value={`${vitals[0].bloodGlucose} mg/dL`}             icon={<FiDroplet />}      statusKey="bloodGlucose"    rawValue={vitals[0].bloodGlucose} />
                    </div>
                    </>
                  )
                )}
                {activeTab === "Test Report" && (
                  labLoading ? (
                    <div className="flex justify-center py-12">
                      <div className="w-8 h-8 border-2 border-[#00BA7E] border-t-transparent rounded-full animate-spin" />
                    </div>
                  ) : labOrders.length === 0 ? (
                    <div className="py-12 text-center text-[14px] text-[#9CA3AF]">
                      No test reports available.
                    </div>
                  ) : (
                    <>
                      <div className="rounded-xl border border-[#E5E7EB] overflow-hidden">
                        <table className="w-full min-w-[700px] text-left">
                          <thead>
                            <tr className="bg-[#F3F6FA]">
                              {["Test Name", "Date",  "Diagnostic center name", "Location","View",].map((col) => (
                                <th key={col} className={`px-5 py-3.5 text-[13px] font-bold text-[#0B2340] border-b border-[#E5E7EB] ${["View","Share"].includes(col) ? "text-center" : ""}`}>
                                  {col}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {labOrders.map((report, i) => (
                              <tr key={report.id || i} className="border-b border-[#F0F0F0] hover:bg-[#F8FBFF] transition-colors">
                                <td className="px-5 py-4 text-[14px] text-[#111827]">
                                  {report.labTestName || report.labTestCode || "—"}
                                </td>
                                <td className="px-5 py-4 text-[14px] text-[#374151] whitespace-nowrap">
                                  {report.createdDate ? report.createdDate.split(" ")[0] : "—"}
                                </td>
                               
                                <td className="px-5 py-4 text-[14px] text-[#374151]">
                                  {report.hospitalName || report.chefacilityName || "—"}
                                </td>
                                 <td className="px-5 py-4 text-[14px] text-[#374151]">
                                  {report.locationName ||  "—"}
                                </td>
                                <td className="px-5 py-4 text-center">
                                  <button
                                    type="button"
                                    disabled={!report.photoName}
                                    onClick={() => report.photoName && setPreviewUrl(`${GOOGLE_STORAGE_BASE}${report.photoName}`)}
                                    className={`transition-colors ${report.photoName ? "text-[#0B4D76] hover:text-[#00BA7E]" : "text-[#C9CDD4] cursor-default"}`}
                                  >
                                    <Eye size={18} strokeWidth={1.5} />
                                  </button>
                                </td>
                               
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* Pagination */}
                      {labTotalPages > 1 && (
                        <div className="flex items-center justify-center gap-1.5 mt-5">
                          <button
                            type="button"
                            onClick={() => setLabPage((p) => Math.max(0, p - 1))}
                            disabled={labPage === 0}
                            className="w-8 h-8 flex items-center justify-center rounded-lg border border-[#E5E7EB] text-[#6B7280] hover:bg-[#F3F4F6] disabled:opacity-40 transition-colors"
                          >
                            <ChevronLeft size={14} />
                          </button>
                          <button type="button" disabled className="text-[13px] text-[#6B7280] px-2">Prev</button>
                          {Array.from({ length: Math.min(labTotalPages, 5) }, (_, i) => i).map((p) => (
                            <button
                              key={p}
                              type="button"
                              onClick={() => setLabPage(p)}
                              className={`w-8 h-8 rounded-lg text-[13px] font-semibold transition-colors ${labPage === p ? "bg-[#2F9D64] text-white" : "border border-[#E5E7EB] text-[#374151] hover:bg-[#F3F4F6]"}`}
                            >
                              {p + 1}
                            </button>
                          ))}
                          {labTotalPages > 5 && <span className="text-[#9CA3AF] text-[13px]">...</span>}
                          {labTotalPages > 5 && (
                            <button
                              type="button"
                              onClick={() => setLabPage(labTotalPages - 1)}
                              className={`w-8 h-8 rounded-lg text-[13px] font-semibold border border-[#E5E7EB] text-[#374151] hover:bg-[#F3F4F6]`}
                            >
                              {labTotalPages}
                            </button>
                          )}
                          <button type="button" disabled className="text-[13px] text-[#6B7280] px-2">Next</button>
                          <button
                            type="button"
                            onClick={() => setLabPage((p) => Math.min(labTotalPages - 1, p + 1))}
                            disabled={labPage === labTotalPages - 1}
                            className="w-8 h-8 flex items-center justify-center rounded-lg border border-[#E5E7EB] text-[#6B7280] hover:bg-[#F3F4F6] disabled:opacity-40 transition-colors"
                          >
                            <ChevronRight size={14} />
                          </button>
                        </div>
                      )}
                    </>
                  )
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Document preview modal */}
      {previewUrl && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
          onClick={() => setPreviewUrl(null)}
        >
          <div
            className="relative bg-white rounded-2xl shadow-2xl overflow-hidden max-w-3xl w-full max-h-[90vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="h-1 bg-gradient-to-r from-[#004376] to-[#00BA7E] shrink-0" />
            <div className="flex items-center justify-between px-5 py-3 border-b border-[#E5E7EB] shrink-0">
              <p className="text-[14px] font-semibold text-[#0B4D76]">Report Preview</p>
              <button
                type="button"
                onClick={() => setPreviewUrl(null)}
                className="w-8 h-8 flex items-center justify-center rounded-lg text-[#9CA3AF] hover:bg-[#F3F4F6] hover:text-[#374151] transition-colors text-xl font-light"
              >
                ✕
              </button>
            </div>
            <div className="flex-1 overflow-auto bg-[#F4F6F8] flex items-center justify-center p-4 min-h-[400px]">
              {/\.(png|jpe?g|gif|webp|bmp|svg)(\?|$)/i.test(previewUrl) ? (
                <img
                  src={previewUrl}
                  alt="Report"
                  className="max-w-full max-h-full rounded-lg object-contain"
                />
              ) : (
                <iframe
                  src={previewUrl}
                  title="Report"
                  className="w-full h-[600px] border-0 rounded-lg"
                />
              )}
            </div>
          </div>
        </div>
      )}
    </OurLayouts>
  );
}

const WORKFLOW_STAGES = [
  { label: "New Lead",              statusVal: 11, conciergeVal: null },
  { label: "Consultation Scheduled",statusVal: 2,  conciergeVal: null },
  { label: "Surgery Recommended",   statusVal: 3,  conciergeVal: null },
  { label: "Surgery Scheduled",     statusVal: 6,  conciergeVal: null },
  { label: "Surgery Completed",     statusVal: null,conciergeVal: 4   },
  { label: "Closed",                statusVal: null,conciergeVal: 5   },
];

function getWorkflowStep(enquiry) {
  const s = Number(enquiry?.status);
  const c = Number(enquiry?.conciergeStatus);
  if (c === 5) return 5;
  if (c === 4) return 4;
  if (s === 6) return 3;
  if (s === 3) return 2;
  if (s === 2) return 1;
  return 0;
}


const SERVICE_TYPE_MAP = { 8: "IPD", 9: "OPD", 10: "Investigation", 11: "Day Care" };
const resolveServiceType = (v) => SERVICE_TYPE_MAP[Number(v)] || (v != null ? String(v) : null);

const ENQUIRY_STATUS_MAP = { 
   0: 'Rejected',
      1: 'Under Process',
      2: 'Discussing with Hospital',
      3: 'Discussing with Patient',
      4: 'Patient Denied',
      5: 'Hospital Denied',
      6: 'Procedure Confirmed',
      7: 'Hold',
      11: 'New',
      12: 'Waiting For Approval'

};
const resolveEnquiryStatus = (v) => ENQUIRY_STATUS_MAP[Number(v)] || (v != null ? String(v) : null);

const SUB_SERVICE_MAP = { 1: "Emergency", 2: "Non-Emergency", 3: "Others" };
const resolveSubServiceType = (v) => SUB_SERVICE_MAP[Number(v)] || (v != null ? String(v) : null);

function FormField({ label, value, required, span2 }) {
  return (
    <div className={span2 ? "col-span-2" : ""}>
      <label className="block text-[12px] text-[#374151] mb-1">
        {label}{required && <span className="text-red-400"> *</span>}
      </label>
      <div className="w-full px-3 py-2 rounded-lg border border-[#E5E7EB] bg-white text-[13px] text-[#374151] min-h-[36px]">
        {value || <span className="text-[#C9CDD4]">—</span>}
      </div>
    </div>
  );
}

function DocButton({ label }) {
  return (
    <button type="button" className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-[#2F9D64]/40 bg-white text-[12px] font-medium text-[#374151] hover:bg-[#F0FBF4] transition-colors">
      <span className="w-2 h-2 rounded-full bg-[#2F9D64]" />
      {label}
    </button>
  );
}

function DocumentsPanel({ enquiry, onPreview }) {
  const [loadingDoc, setLoadingDoc] = useState(null);

  const docs = [
    { label: "ID Proof",       fileName: enquiry?.idProofName },
    { label: "Ration Card",    fileName: enquiry?.idProof1Name },
    { label: "Insurance Card", fileName: enquiry?.insuranceCardName },
    { label: "Medical Report", fileName: enquiry?.medicalReportName || enquiry?.medicalReport },
    { label: "Prescription",   fileName: enquiry?.prescriptionName || enquiry?.prescription },
  ].filter((d) => d.fileName);

  const handleView = async (fileName) => {
    setLoadingDoc(fileName);
    try {
      const token = localStorage.getItem("auth_token");
      const { data } = await axios.get(
        `${HOSPITAL_API_BASE}document/getDocumentURL/${encodeURIComponent(fileName)}`,
        { headers: token ? { Authorization: `Bearer ${token}` } : {} }
      );
      const url = data?.successObject;
      if (url) onPreview(url);
      else toast.error("Document URL not found.");
    } catch (err) {
      console.error("Failed to fetch document URL:", err);
      toast.error("Failed to open document.");
    } finally {
      setLoadingDoc(null);
    }
  };

  return (
    <div className="rounded-xl border border-[#E5E7EB] bg-white overflow-hidden">
      {/* <div className="px-4 py-3 border-b border-[#E5E7EB]">
        <p className="text-[11px] font-bold text-[#9CA3AF] uppercase tracking-widest">Documents</p>
      </div> */}

       <div className="flex items-center gap-2 px-4 py-3 border-b border-[#E5E7EB]" style={{ background: "linear-gradient(90deg, rgba(1,128,123,0.18) 0%, rgba(0,66,118,0.1) 40%, rgba(255,255,255,0.6) 100%)" }}>
            <div style={{ backgroundColor: '#fff', padding: '2px 2px', borderRadius: '5px', width: '25px', height: '25px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img src={Surgerydetailsicon} alt="" className="w-5 h-5" />
            </div>
            <h3 className="text-[13px] font-semibold text-[#374151] mb-0">Documents</h3>
          </div>

      <div className="px-4 py-2">
        {docs.length === 0 ? (
          <p className="text-[13px] text-[#9CA3AF] py-3 text-center">No documents available.</p>
        ) : (
          docs.map((doc) => (
            <div key={doc.fileName} className="flex items-center justify-between py-2.5 border-b border-[#F0F0F0] last:border-0">
              <div className="flex items-center gap-2.5 min-w-0">
                <div className="w-8 h-8 rounded-lg bg-[#EEF4FB] flex items-center justify-center text-[#0B4D76] text-[9px] font-bold shrink-0">PDF</div>
                <div className="min-w-0">
                  <p className="text-[12px] font-medium text-[#374151]">{doc.label}</p>
                  <p className="text-[10px] text-[#9CA3AF] truncate max-w-[140px]">{doc.fileName}</p>
                </div>
              </div>
              <button
                type="button"
                onClick={() => handleView(doc.fileName)}
                disabled={loadingDoc === doc.fileName}
                className="text-[#0B4D76] hover:text-[#00BA7E] transition-colors shrink-0 ml-2 disabled:opacity-50"
              >
                {loadingDoc === doc.fileName ? (
                  <span className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin inline-block" />
                ) : (
                  <Eye size={16} strokeWidth={1.5} />
                )}
              </button>
            </div>
          ))
        )}
      </div>
      
    </div>
  );
}

function SurgeryEnquiryTab({ enquiry, hospTypes = [], onPreview }) {
  if (!enquiry) return <p className="text-[14px] text-[#9CA3AF] py-8 text-center">No data.</p>;

  const currentStep = getWorkflowStep(enquiry);
  const currentStageLabel = WORKFLOW_STAGES[currentStep]?.label || "New Lead";

  return (
    <div className="flex flex-col lg:flex-row gap-5">

      {/* ── Left column ── */}
      <div className="flex-1 space-y-4 min-w-0">

        {/* Suggested surgery & prescription */}
       
 {/* Service details */}
        <div className="rounded-xl border border-[#E5E7EB] bg-white overflow-hidden">
          <div className="flex items-center gap-2 px-4 py-3 border-b border-[#E5E7EB]" style={{ background: "linear-gradient(90deg, rgba(1,128,123,0.18) 0%, rgba(0,66,118,0.1) 40%, rgba(255,255,255,0.6) 100%)" }}>
            <div style={{ backgroundColor: '#fff', padding: '2px 2px', borderRadius: '5px', width: '25px', height: '25px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img src={Surgerydetailsicon} alt="" className="w-5 h-5" />
            </div>
            <h3 className="text-[13px] font-semibold text-[#374151] mb-0">Service details</h3>
          </div>
          <div className="p-4 grid grid-cols-2 gap-3">
            <FormField label="Service Type" value={resolveServiceType(enquiry.serviceType)} />
            <FormField label="Service Sub Type" value={resolveSubServiceType(enquiry.serviceSubTypeId || enquiry.serviceSubType)} />
            <FormField label="Hospitalization Type" value={hospTypes[0]?.hospitalizationType || enquiry.hospitalizationType} />
            <FormField label="Hospitalization Sub Type" value={enquiry.procedureName} />
            {/* <FormField label="Hospitalization Sub Type" value={hospTypes.find(h => String(h.hospitalizationSubTypeId) === String(enquiry.hospitalizationSubType))?.hospitalizationSubType || enquiry.hospitalizationSubType} /> */}
            <FormField label="Planned Start Date" value={enquiry.fromDate?.split("T")[0] || enquiry.procedurePlannedStartDate?.split("T")[0]} />
            <FormField label="Planned End Date" value={enquiry.fromDate?.split("T")[0] || enquiry.procedurePlannedEndDate?.split("T")[0]}  />
            <FormField label="Planned Confirmed Date" value={enquiry.procedurePlannedDate?.split("T")[0]} />
            <FormField label="Status" value={resolveEnquiryStatus(enquiry.status)} />
            <FormField label="Estimate Amount for Procedure" value={enquiry.estimateAmountForProcedure} />
            <FormField label="Do you have any other medical conditions?" value={enquiry.hasOtherMedicalConditions } />
          </div>
        </div>


         <div className="rounded-xl border border-[#E5E7EB] bg-white overflow-hidden">
          <div className="flex items-center gap-2 px-4 py-3 border-b border-[#E5E7EB]" style={{ background: "linear-gradient(90deg, rgba(1,128,123,0.18) 0%, rgba(0,66,118,0.1) 40%, rgba(255,255,255,0.6) 100%)" }}>
            <div style={{ backgroundColor: '#fff', padding: '2px 2px', borderRadius: '5px', width: '25px', height: '25px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img src={Insuranceicon} alt="" className="w-5 h-5" />
            </div>
            <h3 className="text-[13px] font-semibold text-[#374151] mb-0">Insurance details</h3>
          </div>
          <div className="p-4 grid grid-cols-2 gap-3">
            <FormField label="Insurance Id" value={enquiry.insuranceId} />
            <FormField label="Insurance Name" value={enquiry.insuranceName} />
            <FormField label="Insurance Amount" value={enquiry.insuranceAmount} />
          </div>
        </div>
        

       

     
      </div>

      {/* ── Right column ── */}
      <div className="lg:w-[260px] shrink-0 space-y-4">

        {/* Workflow Status */}
        {/* <div className="rounded-xl border border-[#E5E7EB] bg-white overflow-hidden">
          <div className="flex items-center gap-2 px-4 py-3 bg-[#F5F7FA] border-b border-[#E5E7EB]">
            <div className="w-5 h-5 rounded border-2 border-[#6B7280] flex items-center justify-center text-[9px] text-[#6B7280]">✓</div>
            <h3 className="text-[13px] font-semibold text-[#374151]">Workflow Status</h3>
          </div>
          <div className="px-4 py-4">
            <p className="text-[11px] text-[#9CA3AF] mb-1.5">Current status</p>
            <div className="flex items-center justify-between px-3 py-2 rounded-lg border border-[#E5E7EB] bg-[#FAFBFC] mb-4">
              <span className="text-[13px] font-medium text-[#374151]">{currentStageLabel}</span>
              <span className="text-[#9CA3AF] text-[10px]">▼</span>
            </div>
            <p className="text-[10px] font-bold text-[#9CA3AF] uppercase tracking-widest mb-3">Progress</p>
            <div>
              {WORKFLOW_STAGES.map((stage, i) => {
                const done = i < currentStep;
                const active = i === currentStep;
                return (
                  <div key={stage.label} className="flex gap-3">
                    <div className="flex flex-col items-center">
                      <div className={`w-4 h-4 rounded-full flex items-center justify-center shrink-0 mt-0.5 ${
                        done ? "bg-[#2F9D64]" : active ? "border-2 border-[#2F9D64] bg-white" : "border-2 border-[#D1D5DB] bg-white"
                      }`}>
                        {done && <div className="w-1.5 h-1.5 rounded-full bg-white" />}
                        {active && <div className="w-2 h-2 rounded-full bg-[#2F9D64]" />}
                      </div>
                      {i < WORKFLOW_STAGES.length - 1 && (
                        <div className={`w-0.5 h-7 mt-0.5 ${done ? "bg-[#2F9D64]" : "bg-[#E5E7EB]"}`} />
                      )}
                    </div>
                    <div className="pb-1">
                      <p className={`text-[13px] font-medium leading-tight ${done || active ? "text-[#111827]" : "text-[#9CA3AF]"}`}>
                        {stage.label}
                      </p>
                      {done && enquiry.createdDate && i === 0 && (
                        <p className="text-[11px] text-[#9CA3AF] mt-0.5">{enquiry.createdDate?.split(" ")[0]}</p>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div> */}

        {/* Documents */}
        <DocumentsPanel enquiry={enquiry} onPreview={onPreview} />
      </div>
    </div>
  );
}
